import angular from "angular";

import MaintenanceComponent from "./maintenance.component";
import MaintenanceModuleRouting from "./maintenance.module.routing";

import HealthPublicApi from "../../resources/health/public-bicycles.resource";

export default angular
  .module("vt-maintenance", [
    HealthPublicApi.name
  ])
  .config(MaintenanceModuleRouting)
  .component("maintenance", MaintenanceComponent);
